/**
 * ValidityStatusChip Component
 * Displays a colored chip indicating calibration validity status
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  CheckCircle as ValidIcon,
  Warning as WarningIcon,
  Error as ExpiredIcon,
} from '@mui/icons-material';
import {
  ValidityStatus,
  ValidityStatusLabels,
  ValidityStatusColors,
  ValidityStatusChipProps,
} from '../../../types/measurementEquipment';

export const ValidityStatusChip: React.FC<ValidityStatusChipProps> = ({
  status,
  daysUntilExpiry,
  size = 'small',
}) => {
  const getIcon = () => {
    switch (status) {
      case ValidityStatus.VALID:
        return <ValidIcon />;
      case ValidityStatus.WARNING:
        return <WarningIcon />;
      case ValidityStatus.EXPIRED:
        return <ExpiredIcon />;
      default:
        return undefined;
    }
  };

  const getTooltipText = () => {
    if (daysUntilExpiry === undefined) {
      return ValidityStatusLabels[status];
    }

    if (daysUntilExpiry < 0) {
      return `Expirado há ${Math.abs(daysUntilExpiry)} dia(s)`;
    }
    if (daysUntilExpiry === 0) {
      return 'Expira hoje';
    }
    if (daysUntilExpiry === 1) {
      return 'Expira amanhã';
    }
    return `Expira em ${daysUntilExpiry} dias`;
  };

  return (
    <Tooltip title={getTooltipText()} arrow>
      <Chip
        icon={getIcon()}
        label={ValidityStatusLabels[status]}
        color={ValidityStatusColors[status]}
        size={size}
        variant="filled"
      />
    </Tooltip>
  );
};

export default ValidityStatusChip;
